import { createBv } from '@bv/plugins';
import { messages as aiMessages } from '@bvai/locale';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueDatePicker from '@vuepic/vue-datepicker';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { VsxIcon } from 'vue-iconsax';
import VueApexCharts from 'vue3-apexcharts';
import VueClickAway from 'vue3-click-away';
import Vue3EasyDataTable from 'vue3-easy-data-table';
import { PDFPlugin } from 'vue3-pdfmake';

import App from '@/App.vue';
import PresenceMenu from '@/components/Layout/PresenceMenu.vue';
import PresenceStatus from '@/components/Layout/PresenceStatus.vue';
import SipRegisterToggle from '@/components/Layout/SipRegisterToggle.vue';
import UserStatus from '@/components/Layout/UserStatus.vue';
import SidebarSupport from '@/components/MainView/SideBar/SidebarSupport.vue';
import SharedComponents from '@/components/SharedComponents';
import { sidebarModules } from '@/config/sidebar-modules';
import { vObserveVisibility } from '@/directives';
import { messages } from '@/helpers/locale/locale.helper';
import socketHandler from '@/helpers/websocket/socketIO';
import { sip, initAiConfig, initSipRouter } from '@/plugins';
import mainRoute from '@/router/system/system.routes';

// fontawesome
library.add(fas, fab, far);

import './assets/sass/reset.scss';
import 'vue3-easy-data-table/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css';

import '@/assets/sass/_main.scss';

const app = createApp(App);

// Pinia
const pinia = createPinia();

// Initialize AI configuration
initAiConfig();

// UI package
const bv = createBv({
  sip,
  i18n: {
    messages: [messages, aiMessages],
  },
  mainRoute,
  sidebar: {
    modules: sidebarModules,
    actions: [SidebarSupport],
    user: {
      status: UserStatus,
      menu: [PresenceMenu, SipRegisterToggle],
    },
  },
});
app.use(bv);

initSipRouter();

// Directives
app.directive('observe-visibility', vObserveVisibility);
app.use(VueClickAway); // Makes 'v-click-away' directive usable in every component

// Components
app.use(SharedComponents);
app.component('VueDatePicker', VueDatePicker); // Use calendar defaults (optional)
app.component('font-awesome-icon', FontAwesomeIcon);
app.component('EasyDataTable', Vue3EasyDataTable);
app.component('VsxIcon', VsxIcon);
app.use(VueApexCharts);
app.use(PDFPlugin);

// Register Shared Components
app.config.globalProperties.$socket = socketHandler;

app.mount('#app');
